module.exports = __webpack_public_path__ + "img/house_scanning.ab4f06f0.gif";